// The "still there?" checkpoint shown a minute before the idle auto-logoff
// (see useIdleTimeout). Announced rather than silent, so a sonographer who
// stepped away mid-worksheet isn't dropped without a chance to stay — and
// so the logoff itself never reads as a bug.

interface IdleWarningDialogProps {
  secondsLeft: number;
  onStay: () => void;
  onLogoutNow: () => void;
}

export function IdleWarningDialog({
  secondsLeft,
  onStay,
  onLogoutNow,
}: IdleWarningDialogProps) {
  return (
    <>
      <div className="fixed inset-0 z-[80] bg-black/40" aria-hidden="true" />
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="idle-warning-title"
        aria-describedby="idle-warning-body"
        className="fixed left-1/2 top-1/2 z-[80] w-full max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-xl border border-border bg-background-card p-6 shadow-theme-lg focus:outline-none"
        data-cy="idle-warning"
      >
        <h2
          id="idle-warning-title"
          className="text-lg font-semibold text-foreground-heading"
        >
          Still there?
        </h2>
        <p
          id="idle-warning-body"
          className="mt-2 text-sm text-foreground-muted"
        >
          You&apos;ll be signed out in{" "}
          <span
            className="font-semibold text-foreground"
            data-cy="idle-countdown"
          >
            {secondsLeft}
          </span>{" "}
          second{secondsLeft === 1 ? "" : "s"} to protect patient data on this
          workstation.
        </p>
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            onClick={onLogoutNow}
            data-cy="idle-logout-now"
            className="sk-btn sk-sm"
          >
            Log out now
          </button>
          <button
            type="button"
            onClick={onStay}
            autoFocus
            data-cy="idle-stay"
            className="sk-btn sk-btn-primary sk-sm"
          >
            Stay signed in
          </button>
        </div>
      </div>
    </>
  );
}
